import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2, ArrowUpRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";
import Seo from "../components/site/Seo";
import ForgotPasswordDialog from "../components/site/ForgotPasswordDialog";

const FIELD = "w-full border border-border bg-secondary px-4 py-3 text-sm outline-none transition-colors placeholder:text-muted-foreground focus:border-brand";

export default function AdminLogin() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const change = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signIn(form.email, form.password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-background px-5">
      <Seo title="Admin Login" description="VectorBridge Group administrator access." />
      <div className="tech-grid pointer-events-none fixed inset-0 opacity-20" />
      <div className="relative w-full max-w-md border border-border bg-card/70 p-8 backdrop-blur-xl sm:p-10">
        <Link to="/" className="flex items-center gap-3">
          <img src="/vbg-bridge-mark-t.png" alt="VectorBridge Group" className="h-9 w-auto" />
          <span className="font-display text-lg font-bold uppercase tracking-tight text-navy">VectorBridge</span>
        </Link>
        <div className="mt-8 flex items-center gap-2 text-brand"><Lock size={16} /><span className="font-mono text-[11px] uppercase tracking-[0.2em]">Administrator</span></div>
        <h1 className="mt-3 font-display text-3xl font-light tracking-tighter">Sign in to the console.</h1>
        <form onSubmit={submit} data-testid="admin-login-form" className="mt-8 space-y-4">
          <input name="email" type="email" value={form.email} onChange={change} placeholder="Email" className={FIELD} data-testid="admin-email" />
          <input name="password" type="password" value={form.password} onChange={change} placeholder="Password" className={FIELD} data-testid="admin-password" />
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="inline-flex w-full items-center justify-center gap-2 bg-brand px-6 py-4 font-mono text-xs uppercase tracking-[0.15em] text-white transition-colors hover:bg-navy disabled:opacity-60">
            {loading ? <Loader2 size={16} className="animate-spin" /> : <ArrowUpRight size={16} />} Sign in
          </button>
        </form>
        <button type="button" onClick={() => setForgot(true)} data-testid="admin-forgot-password" className="mt-5 font-mono text-[11px] uppercase tracking-[0.15em] text-muted-foreground transition-colors hover:text-brand">Forgot password?</button>
        <ForgotPasswordDialog open={forgot} onOpenChange={setForgot} />
      </div>
    </div>
  );
}
